import {
  WmNavigator,
  WmSelect,
  WmOption,
} from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import translate from "../../../../src/i18n/translate";
import { toggleNavOrgMgt } from "../../../static/js/commons";
import { useContext, useState } from "react";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import {
  Institution,
  InsightsUser,
  defaultInstitution,
  UserInstitution,
} from "../../common/interfaces/Interface";
import { Link } from "react-router-dom";
import MirageStateLink from "@/mirage/MirageStateLink";
const { API_ROOT } = runConfig;

const openHelpCentreLink = () => {
  return window.open(`${API_ROOT}/zendesk/login`, "_blank");
};

export default function InsightsHeader({
  hideNavigatorSideNav,
}: {
  hideNavigatorSideNav?: boolean;
}): JSX.Element {
  const { institution, sysUser } = useContext<AppContextInterface>(AppContext);
  const institutionLogo = useIntl().formatMessage(
    {
      id: "app.header.logo",
    },
    { institutionName: institution?.name }
  );

  return (
    <>
      <header className="top-bar topbar-overlay top-bar-contributor">
        {institution && (
          <>
            {sysUser && sysUser.roles.includes("administrator") && (
              <button
                id="mobile-nav-toggle"
                className={
                  hideNavigatorSideNav ? "icononly show-toggle-nav" : "icononly"
                }
                onClick={toggleNavOrgMgt}
              >
                <span className="sr-only tooltip -left">
                  {translate("app.showNavigation")}
                </span>
                <span className="hamburger-inner"></span>
              </button>
            )}
            <h1
              className="logo"
              id={institution.logoUrl ? "header-logo" : ""}
            >
              <img
                className={
                  hideNavigatorSideNav
                    ? "institution-logo ml-20"
                    : "institution-logo"
                }
                src={institution.logoUrl ?? "/images/Insights-Hub.svg"}
                alt={institutionLogo}
              />
            </h1>
            {sysUser && (
              <NavigationMenu institution={institution} user={sysUser} />
            )}
          </>
        )}
      </header>
      {sysUser && institution && (
        <InstitutionList institution={institution} user={sysUser} />
      )}
    </>
  );
}
const HelpCenter = () => {
  const helpCenterlink = useIntl().formatMessage({
    id: "app.appBar.helpCenterlink",
  });
  return (
    <li className="products dropdown-select">
      <button
        className="header-help-icon"
        tabIndex={0}
        aria-label={helpCenterlink}
        onClick={openHelpCentreLink}
      >
        <i className="mdi mdi-help-circle"></i>
      </button>
    </li>
  );
};

interface NavigationMenuProps {
  institution: Institution;
  user: InsightsUser;
}
const NavigationMenu = ({ institution, user }: NavigationMenuProps) => {
  const { institutionsList, selectedInstitution, setSelectedInstitution } =
    useContext<AppContextInterface>(AppContext);
  const selectInstitution = useIntl().formatMessage({
    id: "app.header.selectInstitution",
  });
  return (
    <div className="menus">
      <ul className="menu-bar nobullets">
        {process.env.NODE_ENV === "development" &&
          process.env.MIRAGE_ENV === "true" && (
            <li className="dev-only-link">
              <MirageStateLink />
            </li>
          )}
        <li
          id="instituition-list"
          className="institution-list topbar-"
          tabIndex={-1}
        >
          <div
            id="hierarchy-select"
            className="prevent-header instituition-select"
          >
            {institutionsList?.length === 1 && (
              <span>{institutionsList[0].name}</span>
            )}
            {institutionsList?.length > 1 && (
              <WmSelect
                label={selectInstitution}
                labelPosition="none"
                id="select-institution"
                data-testid="desktop-institution-select"
              >
                {institutionsList.map((userInstitution: UserInstitution) => {
                  return (
                    <WmOption
                      key={`institution-${userInstitution.uuid}`}
                      selected={
                        selectedInstitution
                          ? selectedInstitution === userInstitution.uuid
                          : institution.platformUuid === userInstitution.uuid
                      }
                      onClick={() => {
                        setSelectedInstitution(userInstitution);
                      }}
                      data-testid={`desktop-institution-option-${userInstitution.uuid}`}
                    >
                      {userInstitution.name}
                    </WmOption>
                  );
                })}
              </WmSelect>
            )}
          </div>
        </li>
        <HelpCenter />
        <Navigator institution={institution} user={user} />
      </ul>
    </div>
  );
};
const Navigator = ({ institution, user }: NavigationMenuProps) => {
  return (
    <li className="products dropdown-select" id="naviagtor-icon">
      {user && (
        <WmNavigator
          id="navigator-example"
          user-name={`${user.firstName} ${user.lastName}`}
          email={user.email}
          logout-url={user.logoutUrl}
          auth-type={institution.authCode}
          products={user.products}
          mode="insights_hub"
          connection-name={user.connectionName}
        ></WmNavigator>
      )}
    </li>
  );
};
const InstitutionList = ({ institution, user }: NavigationMenuProps) => {
  const { institutionsList, selectedInstitution, setSelectedInstitution } =
    useContext<AppContextInterface>(AppContext);
  const selectInstitution = useIntl().formatMessage({
    id: "app.header.selectInstitution",
  });
  return (
    <div className="menus mobile-menus">
      {process.env.NODE_ENV === "development" &&
        process.env.MIRAGE_ENV === "true" && (
          <div>
            <MirageStateLink />
          </div>
        )}
      <div
        id="hierarchy-select"
        className="prevent-header instituition-select"
      >
        {institutionsList?.length === 1 && (
          <span>{institutionsList[0].name}</span>
        )}
        {institutionsList?.length > 1 && (
          <WmSelect
            label={selectInstitution}
            labelPosition="none"
            id="select-institution"
            data-testid="mobile-institution-select"
          >
            {institutionsList.map((userInstitution: UserInstitution) => {
              return (
                <WmOption
                  key={`institution-${userInstitution.uuid}`}
                  selected={
                    selectedInstitution
                      ? selectedInstitution === userInstitution.uuid
                      : institution.platformUuid === userInstitution.uuid
                  }
                  onClick={() => {
                    setSelectedInstitution(userInstitution);
                  }}
                  data-testid={`mobile-institution-option-${userInstitution.uuid}`}
                >
                  {userInstitution.name}
                </WmOption>
              );
            })}
          </WmSelect>
        )}
      </div>
    </div>
  );
};
